import React, { useState, useEffect } from 'react';
import { Grid, Typography, Container, Box, Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Axios from 'axios';
import CardComponent from './PiacComponents/CardComponent';
import config, { environment } from '../../config';

function AllCarListings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);

  useEffect(() => {
    async function fetchCars() {
      try {
        const response = await Axios.get(config[environment].carsEndpoint);
        setListings(response.data.map(l => ({ ...l, key: 'Auto' })));
      } catch (error) {
        console.error("Error fetching cars:", error);
      }
    }
    fetchCars();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 4, mt: '50px' }}>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" sx={{ color: 'var(--sznodarkblue)', fontWeight: 'bold' }}>
          {t('Map.AllCars')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="contained" onClick={() => navigate('/addcar')} sx={{ bgcolor: '#2492be' }}>
              {t('SubMenu.Auto') + " +"}
            </Button>
            <Button variant="contained" onClick={() => navigate('/autoterkep')} sx={{ bgcolor: 'green' }}>
              {t('Map.ShowOnMap', 'Megtekintés térképen')}
            </Button>
            <Button variant="contained" onClick={() => navigate('/terkep')}>
              {t('Map.BackToMap')}
            </Button>
        </Box>
      </Box>
      <Grid container spacing={3}>
        {listings.map((listing) => (
          <Grid item xs={12} sm={6} md={4} key={listing.id}>
            <CardComponent 
              listing={listing} 
              state={{ mapInstance: null }} 
              setFlyToLocation={() => {}} 
              navigate={navigate} 
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default AllCarListings;
